import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
    filtro: {
        data: DateFormat.getDataAtual()
    },
	lista: [],
	listaSelect: [],
    listaSolicitacao: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRODUCAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PRODUCAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PRODUCAO_SET_FILTRO':
			return { ...state,
				filtro: action.payload
			};

        case 'PRODUCAO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };

        case 'PRODUCAO_SOLICITACAO_LISTADO':
            return {
                ...state, 
                listaSolicitacao: action.payload.data
            };
            
        default:
            return state;
    }
}
